module.exports = __webpack_public_path__ + "static/wand_of_fireballs-7be3a1ed3508b1888559c69a9b54f59d.jpeg";